import type { ReactElement } from 'react';
import type { PostDto } from '@gr/core/content/posts/dto';
import { useNavigate, useServices, useT } from '../../../app/di';
import { useResource } from '../../../shared/hooks';
import { Alert } from '../../../ui-kit/Alert/Alert';
import { Loading } from '../../../ui-kit/Loading/Loading';
import { MediaPreview } from '../media';
import { useBlog } from '../../accounts/workspaces';
import { viewerSearch, type ViewerPosition } from './model/post-media-viewer';
import { PostMediaViewer } from './PostMediaViewer/PostMediaViewer';

// POST-UC-13, MED-UC-3.CC-1: просмотр меняет только адрес поста; листание и закрытие не копят историю.
export function PostMediaViewerConnected({ post, mediaId, position }: { post: PostDto; mediaId: string; position: ViewerPosition }): ReactElement {
  const { api, router } = useServices();
  const { t, te } = useT();
  const { blog } = useBlog();
  const navigate = useNavigate();
  const media = useResource(() => api.media.get(blog.id, mediaId), [api, blog.id, mediaId]);
  const postParams = { blogId: blog.id, postId: post.id };
  const libraryHref = `${router.path('mediaItem', { blogId: blog.id, mediaId })}?post=${encodeURIComponent(post.id)}`;

  const preview = media.data ? (
    <MediaPreview key={media.data.id} media={media.data} />
  ) : media.error ? (
    <Alert tone="danger">{te(media.error)}</Alert>
  ) : (
    <Loading label={t('common.loading')} />
  );

  return (
    <PostMediaViewer
      name={media.data?.originalName ?? t('common.loading')}
      position={position}
      preview={preview}
      libraryHref={libraryHref}
      onLibrary={() => router.navigate(libraryHref)}
      onNavigate={(id) => navigate('post', postParams, { search: viewerSearch(id), replace: true, keepScroll: true })}
      onClose={() => navigate('post', postParams, { replace: true, keepScroll: true })}
    />
  );
}
